import { createSelector } from "@reduxjs/toolkit";

import { currentDeploymentSelector } from "Reducers/environment/deployment";

import type { RootState } from "Store/configureStore";

const serviceKindSelector = createSelector(
  (
    state: RootState,
    {
      ids: [organizationId, projectId, environmentId],
      name
    }: { ids: string[]; name: string }
  ) => ({
    currentDeployment: currentDeploymentSelector(state, {
      organizationId,
      projectId,
      environmentId
    }),
    name
  }),

  ({ currentDeployment, name }) => {
    if (!currentDeployment) {
      return;
    }

    if (currentDeployment.services[name]) {
      return "Service";
    }

    if (currentDeployment.webapps[name]) {
      return "Application";
    }

    if (currentDeployment.workers[name]) {
      return "Worker";
    }
  }
);

export default serviceKindSelector;
